export const styles = (theme) => ({
  root: {
    // height: "100%",
    flex: 1,
    backgroundColor:theme.palette.background.common
  },
  searchAndAddButtonContainer: {
    display: "flex",
    gap: "8px",
    "& .App1-MuiInputBase-root": {
      minWidth: "360px",
    },
  },
  searchAndButtonInput: {
    flex: 1,
  },
  addnew: {
    "&.App1-MuiButton-contained:hover": {
      backgroundColor: theme.palette.button.hover
    },
    color:theme.palette.button.text,
    backgroundColor:theme.palette.button.background,
  },
  drugtitle: {
    color: theme.palette.text.primary
  },
  tableContent: {
    height: "100%", // To make container fill full height
    borderRadius: "8px",
    border: "1px solid #DEE5EC",
    boxShadow: "0px 10px 25px #0000000A",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "20px 20px 10px 20px !important",
    backgroundColor: theme.palette.background.table
  },
  G28xA: {
    borderRadius: 7,
  },
  paginationContainer: {
    boxShadow: "unset",
    borderRadius: 0,
    backgroundColor:theme.palette.background.table
    // margin: "0px -20px",
  },
  divider: {
    margin: "0px -20px",
    backgroundColor: "#DEE5EC",
  },
  paginationComponent: {
    marginTop: 4,
  },
});
